import "vue-app/utils/pubSubInitializer";
import { createApp } from "vue";
import PageRegister from "../pages/PageRegister/PageRegister.vue";
import "./icons";
import TranslatePlugin from "../plugins/edroneTranslate/edroneTranslatePlugin";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { createRouter, createWebHistory } from "vue-router";
import "../assets/scss/main.scss";
import "../assets/scss/main.css";
import RegisterPlatforms from "vue-app/components/Register/RegisterPlatforms/RegisterPlatforms.vue";
import RegisterForm from "vue-app/components/Register/RegisterForm/RegisterForm.vue";
import { createPinia } from "pinia";
import RegisterPlatformsAside from "vue-app/components/Register/RegisterPlatforms/RegisterPlatformsAside.vue";
import { usePostHog } from "vue-app/composables/usePostHog";

if (document.querySelector("#register")) {
  const router = createRouter({
    history: createWebHistory("/register/"),
    routes: [
      {
        path: "/:pathMatch(.*)*",
        children: [
          {
            path: "",
            name: "registerPlatforms",
            components: {
              main: RegisterPlatforms,
              aside: RegisterPlatformsAside,
            },
          },
          {
            path: "form",
            name: "registerForm",
            components: {
              main: RegisterForm,
              aside: RegisterPlatformsAside,
            },
          },
        ],
      },
    ],
  });
  usePostHog();
  const app = createApp(PageRegister);
  const pinia = createPinia();
  app.use(router);
  app.use(pinia);
  app.component("font-awesome-icon", FontAwesomeIcon);
  app.use(TranslatePlugin);
  app.mount("#register");
}
